import { Suspense } from 'react';
import FallbackLoading from '../components/FallbackLoading';
import Footer from '../components/layout/Footer';
import Preloader from '../components/Preloader';
import TopNavigationBar from '../components/layout/TopNavigationBar';
import VerticalNavigationBar from '../components/layout/VerticalNavigationBar';
import FcmMessaging from '../components/FcmMessaging';
import { AdminInboxProvider } from '../context/AdminInboxContext';
import { SocketProvider } from '../context/SocketContext';
import { Outlet } from 'react-router-dom';

const AdminLayout = () => (
  <SocketProvider>
    <AdminInboxProvider>
      <FcmMessaging />
      <div className="wrapper">
        <Suspense fallback={<FallbackLoading />}>
          <TopNavigationBar />
        </Suspense>
        <Suspense fallback={<FallbackLoading />}>
          <VerticalNavigationBar />
        </Suspense>
        <div className="page-content">
          <div className="container-xxl">
            <Suspense fallback={<Preloader />}>
              <Outlet />
            </Suspense>
          </div>
          <Footer />
        </div>
      </div>
    </AdminInboxProvider>
  </SocketProvider>
);

export default AdminLayout;
